import { Injectable } from '@angular/core';
import { PagedResponse, RequestResponse } from '@core/services/request/model/request.model';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { IndividualSocietyApi } from '@core/api/model/my-services/individual-society-api.model';
import { IndividualSocietyInstallationsAPI } from '@core/api/model/my-services/individual-society-installations-api.model';
import { IndividualInstallationApi } from '@core/api/model/my-services/individual-installation-api.model';
import { MyServicesListingFilterApi, MyServicesListingSocietyApi } from '@core/api/model/my-services/my-services-listing-api.model';
import { LoadingIds } from '@shared/constants/loading';
import { ProcedureListingApi } from '@core/api/model/my-procedures/procedures-listings-api.model';

@Injectable({
  providedIn: 'root',
})
export class ApiMyServicesService {
  /**
   *
   * @param _requestService @see RequestService
   * @param _httpParamsService @see HttpParamsService
   */
  constructor(
    private readonly _requestService: RequestService,
    private readonly _httpParamsService: HttpParamsService
  ) {}

  public fetchMyServices(request: MyServicesListingFilterApi): Observable<RequestResponse<PagedResponse<MyServicesListingSocietyApi>>> {
    return this._requestService.get<RequestResponse<PagedResponse<MyServicesListingSocietyApi>>>(
      ApiDirectory.ServiciosContratados.ProductosContratados({}),
      { params: this._httpParamsService.toParams(request), loading: LoadingIds.FETCH_MY_SERVICES_LISTING }
    );
  }

  /**
   * Fetch a society given its code
   */
  fetchSociety(code: string): Observable<RequestResponse<IndividualSocietyApi>> {
    return this._requestService.get(
      ApiDirectory.ServiciosContratados.Sociedad({
        idSociedad: code,
      })
    );
  }

  /**
   * Fetch the installations of a society given its code
   */
  fetchSocietyInstallations(code: string): Observable<RequestResponse<Array<IndividualSocietyInstallationsAPI>>> {
    return this._requestService.get(
      ApiDirectory.ServiciosContratados.InstalacionesSociedad({
        idSociedad: code,
      })
    );
  }

  /**
   * Fetch an installation given its code
   */
  fetchInstallation(cups: string): Observable<RequestResponse<IndividualInstallationApi>> {
    return this._requestService.get(
      ApiDirectory.ServiciosContratados.Instalacion({
        cups,
      })
    );
  }

  /**
   * Fetch Installation Procedures
   */
  public fetchInstallationProcedures(cups: string): Observable<RequestResponse<Array<ProcedureListingApi>>> {
    return this._requestService.get(
      ApiDirectory.ServiciosContratados.TramitesInstalacion({
        cups,
      })
    );
  }
}
